import { Box, Text } from '@chakra-ui/react';
import React from 'react';
import { useTranslation } from 'react-i18next';

interface IRequestStatusProps {
  status: 'approved' | 'declined' | 'pending' | 'withdrawn';
}

const RequestStatus: React.FC<IRequestStatusProps> = ({ status = 'pending' }) => {
  const [t] = useTranslation(['timeOff', 'common']);

  const statusMap = {
    approved: {
      label: t('common:approved'),
      bgColor: 'success.500',
      textColor: 'white',
    },
    declined: {
      label: t('common:declined'),
      bgColor: 'secondary.700',
      textColor: 'white',
    },
    withdrawn: {
      label: t('common:withdrawn'),
      bgColor: 'newGray.500',
      textColor: 'white',
    },
    pending: {
      label: t('common:pending'),
      bgColor: 'warning.200',
      textColor: 'warning.1000',
    },
  };

  const { label, bgColor, textColor } = statusMap[status];

  return (
    <Box
      display="inline-block"
      color={textColor}
      textTransform="uppercase"
      padding="4px 8px"
      backgroundColor={bgColor}
      borderRadius="4px"
    >
      <Text fontSize="xs">{label}</Text>
    </Box>
  );
};

export default RequestStatus;
